export const getTextFields = (industryData: any) => [
    {
        id: "industry",
        name: "name",
        label: "Name",
        type: "text",
        placeholder: "Enter Name",
        required: true,
        capitalizedFirst: true,
        value: industryData?.name
    },
    {
        label: "Status",
        value: industryData?.enabled === true ? 'Enabled' : 'Disabled',
        formField: false,
    },
  
];